export default "__VITE_ASSET__GkFdXfzg__"